import type { LandingPartnerPublic, PortfolioClientLogo } from '@repo/api-contracts';
import { portfolioDetailPath } from '@/shared/config';

export interface ClientLogoItem {
  readonly id: string;
  /** 접근성 이름(대체 텍스트). */
  readonly name: string;
  readonly logoUrl: string;
  /** 누르면 가는 곳 — 사례 로고는 그 제작 사례 상세, 운영자 등록 로고는 없음. */
  readonly href: string | null;
}

/**
 * HOME 함께한 브랜드 로고 목록 — 운영자가 랜딩 관리에서 등록한 기업 로고가 하나라도 있으면 그것만 쓰고,
 * 없으면 고객사명·로고가 있는 공개 제작 사례의 로고를 쓴다(각 사례 상세로 링크).
 */
export const clientLogoItems = (
  partners: readonly LandingPartnerPublic[],
  cases: readonly PortfolioClientLogo[],
): readonly ClientLogoItem[] =>
  partners.length > 0
    ? partners.map((partner) => ({
        id: partner.id,
        name: partner.name,
        logoUrl: partner.imageUrl,
        href: null,
      }))
    : cases.map((item) => ({
        id: item.id,
        name: item.clientName,
        logoUrl: item.brandLogoUrl,
        href: portfolioDetailPath(item.id),
      }));
